@use '../../scss/utility/functions' as utility;

$small-round-button-height: utility.wb-pixel-to-rem(36px);

:host {
  /** @prop --gradient-start-color: the start color of the linear gradient on the sides of the horizontal scroll */
  --gradient-start-color: var(--parent-background-color);

  /** @prop --gradient-end-color: the end color of the linear gradient on the sides of the horizontal scroll */
  --gradient-end-color: var(--wb-transparent);
  display: block;
  overflow: hidden;
  position: relative;
}

:host([hide-arrow-navigation]) {
  &.has-start-gradient::before,
  &.has-end-gradient::after {
    border-width: 0;
  }
}

.container {
  margin: 0 calc(-1 * var(--wb-spacing-xxs));

  &::before,
  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
    box-sizing: content-box;
    z-index: 1;
    inset-block: 0;
    width: 0;
    transition: width 0.3s var(--wb-fade);
  }

  &::before {
    background: linear-gradient(to right, var(--gradient-start-color) var(--wb-spacing-xxs), var(--gradient-end-color));
    inset-inline-start: 0;
  }

  &::after {
    background: linear-gradient(to left, var(--gradient-start-color) var(--wb-spacing-xxs), var(--gradient-end-color));
    inset-inline-end: 0;
  }
}

.has-start-gradient::before,
.has-end-gradient::after {
  box-sizing: content-box;
  width: var(--wb-spacing-m);
}

.has-start-gradient::before {
  border-inline-start: 36px solid var(--gradient-start-color);
}

.has-end-gradient::after {
  border-inline-end: 36px solid var(--gradient-start-color);
}

.inner {
  display: flex;
  min-height: $small-round-button-height;
  overflow-y: scroll;
  scrollbar-width: none;
  align-items: center;
  margin: 0 var(--wb-spacing-xxs);

  &::-webkit-scrollbar {
    display: none;
  }
}

.pixel {
  width: utility.wb-pixel-to-rem(1px);
  height: utility.wb-pixel-to-rem(1px);
  display: inline-block;
  flex-shrink: 0;
}

.arrow {
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);
  z-index: 2;
}

.is-start {
  inset-inline-start: 0;
}

.is-end {
  inset-inline-end: 0;
}

:host([is-rtl]) {
  .container::before {
    background: linear-gradient(to left, var(--gradient-start-color) var(--wb-spacing-xxs), var(--gradient-end-color));
  }

  .container::after {
    background: linear-gradient(to right, var(--gradient-start-color) var(--wb-spacing-xxs), var(--gradient-end-color));
  }
}

::slotted(*) {
  flex-grow: 1;
}
